module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-nav-template patrimonial-landscape white-box row"
  }, [_c('div', {
    staticClass: "menu column"
  }, [_c('div', {
    staticClass: "title row"
  }, [_c('span', {
    staticClass: "icon-eye"
  }), _vm._v(" "), _c('div', {
    staticClass: "ctn-title column"
  }, [_c('div', {
    staticClass: "label row"
  }, [_vm._v("\n\t\t\t\t\t\tPaysage Patrimonial\n\t\t\t\t\t")]), _vm._v(" "), (_vm.estate) ? _c('div', {
    staticClass: "subtitle"
  }, [(_vm.estate.completedAt) ? [_vm._v("\n              Signé le " + _vm._s(_vm.estate.completedAt) + "\n            ")] : (!_vm.isAnonymous) ? [_vm._v("\n              Non signé\n            ")] : _vm._e()], 2) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "view column"
  }, [_c('div', {
    staticClass: "head row"
  }, [(_vm.estate && _vm.estate.updatedAt) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tMise à jour du " + _vm._s(_vm.estate.updatedAt) + "\n\t\t\t\t")]) : _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t\t\tPas de paysage patrimonial existant\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "ctn-cta"
  }, [(!_vm.isAnonymous) ? _c('button', {
    staticClass: "btn btn-gold",
    class: {
      'btn-disabled': !_vm.canDownload
    },
    attrs: {
      "disabled": !_vm.canDownload
    },
    on: {
      "click": function($event) {
        return _vm.downloadEstate()
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-download"
  }), _vm._v(" Télécharger mon Paysage Patrimonial\n\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-red",
    attrs: {
      "tag": "button",
      "to": {
        name: 'PatrimonialLandscapeUpdate'
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\tMettre à jour\n\t\t\t\t\t")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "ctn-component"
  }, [_c('div', {
    staticClass: "ctn-tile row"
  }, [_c('div', {
    staticClass: "tile column"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "body-tile"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Age")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.birthdate))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Métier")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.job || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("CSP")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.csp || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Statut")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.maritalStatus || '-'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile column"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "body-tile"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Revenu annuel")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.incomes || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Immobilier")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.immobilier || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Epargne")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.savings || '-'))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile column"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "body-tile"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Hors impots")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.spendingNoTaxes.value || '-') + " " + _vm._s((_vm.estate.spendingNoTaxes.value) ? _vm.estate.spendingNoTaxes.cur : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Crédit")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.total.loans || '-'))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "ctn-tile row"
  }, [_c('div', {
    staticClass: "tile column"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "body-tile"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Impôt sur le revenu")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.taxes.value || '-') + " " + _vm._s((_vm.estate.taxes.value) ? _vm.estate.taxes.cur : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Déclaration ISF")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.isf.amount || '-') + " " + _vm._s((_vm.estate.taxes.value) ? _vm.estate.isf.cur : ''))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile column"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "body-tile"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Départ retraite")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.retreat.month || '-') + " " + _vm._s(_vm.estate.retreat.year))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("PERP")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.PERPcomputed))])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile column"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "body-tile"
  }, [_c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Suivi")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.follow.rate || '-'))])]), _vm._v(" "), _c('div', {
    staticClass: "item row"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Connaissance")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.estate.knowledge.level || '-'))])])])])])])]), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.displayLegalEstate,
      "content": _vm.contentModalLegalEstate
    },
    on: {
      "close": function($event) {
        _vm.displayLegalEstate = false
      }
    }
  }), _vm._v(" "), _c('base-modal', {
    attrs: {
      "show": _vm.displayRgpdModal,
      "content": _vm.contentModalRgpd
    },
    on: {
      "close": function($event) {
        _vm.displayRgpdModal = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-tile row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Vous")]), _vm._v(" "), _c('span', {
    staticClass: "icon-paysage-vous"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-tile row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Avoirs & Rentrées")]), _vm._v(" "), _c('span', {
    staticClass: "icon-paysage-rentree"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-tile row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Sorties")]), _vm._v(" "), _c('span', {
    staticClass: "icon-paysage-sortis"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-tile row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Fiscalité")]), _vm._v(" "), _c('span', {
    staticClass: "icon-paysage-fiscalite"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-tile row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Retraite")]), _vm._v(" "), _c('span', {
    staticClass: "icon-paysage-retraite"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head-tile row"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Profil")]), _vm._v(" "), _c('span', {
    staticClass: "icon-paysage-profil"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65a35dac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/MyPatrimonialLandscape/Display.vue
// module id = 1141
// module chunks = 0